import { API } from 'aws-amplify';
import { useContext, useState } from 'react';
import { ShipyardContext } from '../Context';
import { useLocation } from 'react-router-dom';

function useClientBasicInfo() {
    const location = useLocation();
    const { updateUserSettings } = useContext(ShipyardContext);
    const [loading, setLoading] = useState(true);
    const [found, setFound] = useState(false);
    const clientSubdirectoryRgx = /^\/([A-Za-z0-9]+)$/;

    const retrieveClientBasicInfo = async () => {
        try {
            if (!clientSubdirectoryRgx.test(location.pathname)) {
                setFound(false);
                setLoading(false);
                return;
            }
            let rgxMatch = location.pathname.match(clientSubdirectoryRgx);
            let clientShortname = rgxMatch[1].toLowerCase();
            let clientInfo = await API.get('ShipyardAPINoAuth', '/client', {
                queryStringParameters: {
                    shortname: clientShortname,
                },
            });
            updateUserSettings((prev) => {
                return Object.assign(prev, {
                    ClientOrgId: clientInfo.id,
                    ClientHeaderImage: clientInfo.loginHeaderImage,
                    ClientHeaderText: clientInfo.loginHeaderText,
                    ClientName: clientInfo.name,
                });
            });
            setFound(true);
            setLoading(false);
        } catch (err) {
            console.error('Error determining client from short name.', err);
            setFound(false);
            setLoading(false);
        }
    };

    return { loading, found, retrieveClientBasicInfo };
}

export default useClientBasicInfo;
